import {
    apiGetHouseMgtList
    } from "@/apis/api.js";

/*
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_house_list: 'houseManagement/set_house_list',
    set_mode: 'houseManagement/set_mode',
    set_filter_query: 'houseManagement/set_filter_query',
    set_filter_query_county: 'houseManagement/set_filter_query_county',
    set_filter_query_district: 'houseManagement/set_filter_query_district',
    set_filter_word: 'houseManagement/set_filter_word',
    set_filter_result_total: 'houseManagement/set_filter_result_total',
    set_filter_default: 'houseManagement/set_filter_default',
    set_cluster_id: 'houseManagement/set_cluster_id',
    set_house_marker_center: 'houseManagement/set_house_marker_center',
    set_loading: 'houseManagement/set_loading'

}

// count state 必須是 Object
const state = {
    houseMgtList: [],
    filterQuery: {
        county: '',
        countyId: '',
        district: '',
        rent: [0, 100000],
        houseType: '',
        buildingType: '',
        task: '',
        status: ''
    },
    filterTotal: {
        all: 0,
        rented: 0,
        rent: 0,
    },
    clusterHouseId: [],
    houseMarkerCenter: {},
    filterWord: '',
    filterResultTotal: '',
    mode: null,
    isDefault: true,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_HOUSE_MGT_LIST: (state) => {
        return state.houseMgtList
    },
    GET_HOUSE_MGT_MODE: (state) => {
        return state.mode
    },
    GET_HOUSE_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_HOUSE_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_HOUSE_MGT_FILTER_RESULT_TOTAL: (state) => {
        return state.filterTotal
    },
    GET_HOUSE_MGT_FILTER_COUNTY: (state) => {
        return state.filterQuery.county
    },
    GET_HOUSE_MGT_FILTER_COUNTY_IS_EMPTY: (state) => {
        if( state.filterQuery.county == '' ){
            return true
        }else{
            return false
        }
    },
    GET_HOUSE_MGT_FILTER_DISTRICT_IS_EMPTY: (state) => {
        if( state.filterQuery.district == '' ){
            return true
        }else{
            return false
        }
    },
    GET_HOUSE_MGT_FILTER_WORD_IS_EMPTY: (state) => {
        if( state.filterWord == '' ){
            return true
        }else{
            return false
        }
    },
    GET_HOUSE_MGT_HOUSE_TYPE_IS_EMPTY: (state) => {
        if( state.filterQuery.houseType == '' ){
            return true
        }else{
            return false
        }
    },
    GET_HOUSE_MGT_BUILDING_TYPE_IS_EMPTY: (state) => {
        if( state.filterQuery.buildingType == '' ){
            return true
        }else{
            return false
        }
    },
    GET_HOUSE_MGT_TASK_IS_EMPTY: (state) => {
        if( state.filterQuery.task == '' ){
            return true
        }else{
            return false
        }
    } ,
    GET_HOUSE_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_HOUSE_MGT_CLUSTER_HOUSE_ID: (state) => {
        return state.clusterHouseId
    },
    GET_HOUSE_MGT_MARKER_CENTER: (state) => {
        return state.houseMarkerCenter
    }
    ,
    GET_HOUSE_MGT__LOADING: (state) => {
        return state.isLoading
    }
}

// actions 也是以 Object 形式建構。
const actions = {
    getHouseMgtList ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            apiGetHouseMgtList()
            .then(res => {
                // console.log(res)
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    if(res.data.result.houseList != undefined){
                        commit(types.set_house_list, res.data.result.houseList);
                    }
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })

        })
    },
    setHouseMgtFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setHouseMgtFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setHouseMgtFilterResultTotal ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, value);
            resolve()
        })
    },
    setHouseMgtFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
    setHouseMgtMode ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_mode, data);
            resolve()
        })
    }
}

// mutations
const mutations = {
    [types.set_house_list](state, data){
        state.houseMgtList = data
    },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_query_county](state, data){
        state.filterQuery.county = data
        state.isDefault = false
    },
    [types.set_filter_query_district](state, data){
        state.filterQuery.district = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        if(data.type == 'all'){
            state.filterTotal.all = data.count
        }else if (data.type == 'rented'){
            state.filterTotal.rented = data.count
        }else if (data.type == 'rent'){
            state.filterTotal.rent = data.count
        }
    },
    [types.set_filter_default](state){
        state.filterQuery.county = ''
        state.filterQuery.countyId = ''
        state.filterQuery.district = ''
        state.filterQuery.rent = [0, 100000]
        state.filterQuery.task= null
        state.filterQuery.houseType= null
        state.filterQuery.buildingType= null
        state.filterWord = ''
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_cluster_id](state, data){
        state.clusterHouseId = data
    },
    [types.set_house_marker_center](state, data){
        state.houseMarkerCenter = data
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/landlord/houseManagement.js